import "./Tuyendung.css";
const steps = [
  ['Tiếp nhận', 'Nhận khách hàng từ hệ thống', 'Tiếp nhận 100% khách hàng có nhu cầu từ quảng cáo Marketing, không phải tự tìm kiếm khách hàng.'],
  ['Gọi điện', 'Tư vấn theo kịch bản', 'Gọi điện và tư vấn dịch vụ theo đúng quy trình, kịch bản chuẩn của công ty.'],
  ['Khai thác', 'Tìm hiểu nhu cầu khách hàng', 'Khai thác nhu cầu, giải đáp thắc mắc và thuyết phục khách hàng sử dụng dịch vụ.'],
  ['Hướng dẫn', 'Chuẩn bị hồ sơ giao dịch', 'Hướng dẫn khách hàng chuẩn bị thông tin cần thiết để thực hiện giao dịch.'],
  ['Chăm sóc', 'Theo sát đến khi hoàn tất', 'Theo dõi, chăm sóc khách hàng trong suốt quá trình tư vấn đến khi hoàn tất giao dịch.'],
  ['Cập nhật', 'Ghi nhận lên hệ thống', 'Cập nhật đầy đủ nội dung trao đổi và trạng thái khách hàng lên hệ thống quản lý.'],
  ['Phối hợp', 'Xử lý hồ sơ cùng bộ phận liên quan', 'Phối hợp với các bộ phận liên quan để xử lý hồ sơ và hỗ trợ khách hàng nhanh chóng.'],
  ['Đào tạo', 'Họp và báo cáo hằng ngày', 'Tham gia đào tạo, họp trực tuyến và báo cáo kết quả công việc hằng ngày.'],
];

export default function Section() {
  return (
    <section id="mota">
      <div className="wrap">
        <div className="sec-head">
          <div className="sec-eyebrow">Mô tả công việc</div>
          <h2 className="sec-title">Một ngày làm việc của bạn đi theo quy trình gọi</h2>
          <p className="sec-sub">
            Toàn bộ công việc bám theo quy trình và kịch bản có sẵn của công ty.
            Bạn không cần tự tìm khách, chỉ cần thực hiện đúng từng bước.
          </p>
        </div>

        <div className="script">
          {steps.map(([phase, title, description], index) => (
            <div className="script-row" key={phase}>
              <div className="script-time"><span className="n">{String(index + 1).padStart(2, '0')}</span>{phase}</div>
              <div className="script-body"><h4>{title}</h4><p>{description}</p></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}